
import { Component, Vue } from "vue-property-decorator";
@Component
export default class NavigationFooter extends Vue {
  contactUs = false;
  mounted() {
    this.contactUs = false;
  }

  public displayTerms() {
    this.$router.push({ name: "terms" });
  }
}
